<template>
  <div v-if="dataPermission.includes('CNPS_CSTM_NEXTLEND_LIST')">
    <iframe :src="urlFrame"></iframe>
  </div>
</template>

<script>
  import { NextlendService } from '@/services/nextlend.service'
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        urlFrame: '',
        loading: false,
      }
    },
    created() {
      this.equityNL()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async equityNL() {
        try {
          const data = await NextlendService.listEquity()
          if (data.success && this.dataPermission.includes('CNPS_CSTM_NEXTLEND_LIST')) {
            // window.open(`${data.data}`, '_blank')
            this.urlFrame = data.data
          }
        } catch (e) {
          console.log(e)
        }
      },
    },
  }
</script>

<style>
  iframe {
    aspect-ratio: 16 / 9;
    height: 100%;
    width: 100%;
  }
</style>
